// Theme: luminous-blue
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'luminous-blue',
  name: 'LUMINOUS BLUE',
  tagline: 'LUMINOUS BLUE',
  description: 'Azul eletrico em camadas epicas com luz difusa controlada.',
  category: 'cosmic-scale',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#0D1433', '#152040', '#3B82F6', '#DBEAFE'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-sans theme-luminous-blue'
  },
  colorVars: {
    '--accent': '#3B82F6',
    '--accent-foreground': '#0D1433',
    '--background': '#0D1433',
    '--border': '#2A4A8F',
    '--card': '#152040',
    '--card-border-active': 'rgba(59, 130, 246, 0.55)',
    '--card-completed': '#121B36',
    '--card-foreground': '#DBEAFE',
    '--card-glow': 'rgba(59, 130, 246, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#DBEAFE',
    '--hold-fill': '#3B82F6',
    '--input': '#2A4A8F',
    '--modal-bg': '#0D1433',
    '--modal-border': '#2A4A8F',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#2A4A8F',
    '--muted-foreground': '#DBEAFE',
    '--nav-active': '#3B82F6',
    '--nav-bg': '#152040',
    '--popover': '#152040',
    '--popover-foreground': '#DBEAFE',
    '--primary': '#3B82F6',
    '--primary-foreground': '#0D1433',
    '--ring': '#3B82F6',
    '--secondary': '#2A4A8F',
    '--secondary-foreground': '#DBEAFE',
    '--streak': '#3B82F6',
    '--success': '#22c55e',
    '--success-foreground': '#0D1433',
    '--xp': '#3B82F6',
    '--xp-bg': '#152040'
  },
  resolvedVars: {
    '--accent': '#3B82F6',
    '--accent-foreground': '#0D1433',
    '--accent-foreground-hsl': '229 59% 13%',
    '--accent-foreground-oklch': 'from #0D1433 l c h',
    '--accent-hsl': '217 91% 60%',
    '--accent-oklch': 'from #3B82F6 l c h',
    '--background': '#0D1433',
    '--background-hsl': '229 59% 13%',
    '--background-oklch': 'from #0D1433 l c h',
    '--border': '#2A4A8F',
    '--border-hsl': '221 55% 36%',
    '--border-oklch': 'from #2A4A8F l c h',
    '--border-w': '1px',
    '--card': '#152040',
    '--card-border-active': 'rgba(59, 130, 246, 0.55)',
    '--card-completed': '#121B36',
    '--card-completed-hsl': '225 50% 14%',
    '--card-completed-oklch': 'from #121B36 l c h',
    '--card-foreground': '#DBEAFE',
    '--card-foreground-hsl': '214 95% 93%',
    '--card-foreground-oklch': 'from #DBEAFE l c h',
    '--card-glow': 'rgba(59, 130, 246, 0.10)',
    '--card-hsl': '225 51% 17%',
    '--card-oklch': 'from #152040 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#DBEAFE',
    '--foreground-hsl': '214 95% 93%',
    '--foreground-oklch': 'from #DBEAFE l c h',
    '--hold-fill': '#3B82F6',
    '--hold-fill-hsl': '217 91% 60%',
    '--hold-fill-oklch': 'from #3B82F6 l c h',
    '--input': '#2A4A8F',
    '--input-hsl': '221 55% 36%',
    '--input-oklch': 'from #2A4A8F l c h',
    '--modal-bg': '#0D1433',
    '--modal-bg-hsl': '229 59% 13%',
    '--modal-bg-oklch': 'from #0D1433 l c h',
    '--modal-border': '#2A4A8F',
    '--modal-border-hsl': '221 55% 36%',
    '--modal-border-oklch': 'from #2A4A8F l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#2A4A8F',
    '--muted-foreground': '#DBEAFE',
    '--muted-foreground-hsl': '214 95% 93%',
    '--muted-foreground-oklch': 'from #DBEAFE l c h',
    '--muted-hsl': '221 55% 36%',
    '--muted-oklch': 'from #2A4A8F l c h',
    '--nav-active': '#3B82F6',
    '--nav-active-hsl': '217 91% 60%',
    '--nav-active-oklch': 'from #3B82F6 l c h',
    '--nav-bg': '#152040',
    '--nav-bg-hsl': '225 51% 17%',
    '--nav-bg-oklch': 'from #152040 l c h',
    '--popover': '#152040',
    '--popover-foreground': '#DBEAFE',
    '--popover-foreground-hsl': '214 95% 93%',
    '--popover-foreground-oklch': 'from #DBEAFE l c h',
    '--popover-hsl': '225 51% 17%',
    '--popover-oklch': 'from #152040 l c h',
    '--primary': '#3B82F6',
    '--primary-foreground': '#0D1433',
    '--primary-foreground-hsl': '229 59% 13%',
    '--primary-foreground-oklch': 'from #0D1433 l c h',
    '--primary-hsl': '217 91% 60%',
    '--primary-oklch': 'from #3B82F6 l c h',
    '--radius': '12px',
    '--ring': '#3B82F6',
    '--ring-hsl': '217 91% 60%',
    '--ring-oklch': 'from #3B82F6 l c h',
    '--secondary': '#2A4A8F',
    '--secondary-foreground': '#DBEAFE',
    '--secondary-foreground-hsl': '214 95% 93%',
    '--secondary-foreground-oklch': 'from #DBEAFE l c h',
    '--secondary-hsl': '221 55% 36%',
    '--secondary-oklch': 'from #2A4A8F l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#3B82F6',
    '--streak-hsl': '217 91% 60%',
    '--streak-oklch': 'from #3B82F6 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0D1433',
    '--success-foreground-hsl': '229 59% 13%',
    '--success-foreground-oklch': 'from #0D1433 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(217 91% 60% / 0.15)',
    '--xp': '#3B82F6',
    '--xp-bg': '#152040',
    '--xp-bg-hsl': '225 51% 17%',
    '--xp-bg-oklch': 'from #152040 l c h',
    '--xp-hsl': '217 91% 60%',
    '--xp-oklch': 'from #3B82F6 l c h'
  }
}
